export default __webpack_public_path__ + "static/media/Profile_Icon.2f3310ec.svg";